export class IcaRateImportModel {
    counter: number = 0;
    departmentCode: string = "";
    cityCode: string = "";
    conceptInvoicingCode: number = 0;
    rate: number = 0;
    minimumBase: number = 0;
    code: string = "";
    saleAccount: string = "";
    saleDevolutionAccount: string = "";
    payAccountSelfWithholdingICA: string = "";
    devolutionAccountSelfWithholdingICA: string = "";

    constructor(
        counter: number,
        departmentCode: string,
        cityCode: string,
        conceptInvoicingCode: number,
        rate: number,
        minimumBase: number,
        code: string,
        saleAccount: string,
        saleDevolutionAccount: string,
        payAccountSelfWithholdingICA: string,
        devolutionAccountSelfWithholdingICA: string
    ) {
        this.counter = counter;
        this.departmentCode = departmentCode;
        this.cityCode = cityCode;
        this.conceptInvoicingCode = conceptInvoicingCode;
        this.rate = rate;
        this.minimumBase = minimumBase;
        this.code = code;
        this.saleAccount = saleAccount;
        this.saleDevolutionAccount = saleDevolutionAccount;
        this.payAccountSelfWithholdingICA = payAccountSelfWithholdingICA;
        this.devolutionAccountSelfWithholdingICA = devolutionAccountSelfWithholdingICA;
    }
}